module.exports = __webpack_public_path__ + "img/certified-bg.b0edd5f6.svg";